class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Safari doesn't focus a <summary> on click, so 'focusout' never fires when
    // opening another menu or clicking elsewhere on the page. Close explicitly
    // instead of relying on focus.
    this.mainDetailsToggle.addEventListener('toggle', this.onOpenStateChange.bind(this));
    this.onDocumentClickEvent = this.onDocumentClick.bind(this);

    // New Safari (18.4+) keeps the content of a closed <details> painted when
    // the open attribute is removed by script. Clear the inline hiding right
    // before a user-initiated open so the menu can show again.
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', () => {
      if (!this.mainDetailsToggle.open && this.content) this.content.style.removeProperty('display');
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClickEvent);
  }

  onOpenStateChange() {
    if (this.mainDetailsToggle.open) {
      if (this.content) this.content.style.removeProperty('display');
      this.closeOtherDisclosures();
      document.addEventListener('click', this.onDocumentClickEvent);
    } else {
      if (this.content) this.content.style.display = 'none';
      document.removeEventListener('click', this.onDocumentClickEvent);
    }
  }

  closeOtherDisclosures() {
    const scope = this.closest('.header-wrapper') || document;
    scope.querySelectorAll('details-disclosure, header-menu').forEach((disclosure) => {
      if (disclosure !== this && typeof disclosure.close === 'function') disclosure.close();
    });
  }

  onDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.close();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    if (this.content) {
      // The filled animateMenuOpen animation keeps the submenu on its own
      // compositing layer; cancel it so nothing pins the closed dropdown.
      this.content.getAnimations().forEach((animation) => animation.cancel());
      this.content.style.display = 'none';
    }
    // New Safari (18.4+) can keep painting the closed dropdown even though its
    // computed display is none — the render subtree of a details element
    // closed by script is not torn down. Hiding the details itself for one
    // synchronous style/layout pass forces WebKit to rebuild that subtree.
    this.mainDetailsToggle.style.display = 'none';
    this.mainDetailsToggle.offsetHeight;
    this.mainDetailsToggle.style.removeProperty('display');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
